import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiKeys from "../Apikeys";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useNavigate, useParams } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";
import Geocode from "react-geocode";
import Toastmodal from "../Toastmodal";
import { useAuthHandling } from '../useAuthhandling';

import { MultiSelect } from "react-multi-select-component";
import SkillsMultiSelect from "./SkillsMultiSelect";
import ProfSkills from "./ProfSkills";
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
Geocode.setLocationType("ROOFTOP");


function Professionaledit() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  let { id } = useParams();
  const [mobile, setMobile] = useState();

  const [prof, setProf] = useState([]);
  const [subCat, setSubcat] = useState([]);
  const [user, setUserid] = useState([]);
  const [addressstring, setaddressstring] = useState("");
  const [pass, setPass] = useState({
    password: "",
    cpassword: "",
  });
  const [skillsnew, setSkillsnew] = useState([]);
  const [service, setService] = useState([]);
  const [location, setLocation] = useState([]);
  const [formerror, setError] = useState({});
  const [formerrors, setErrors] = useState({});
  const [formerror1, setError1] = useState({});

  const [selectedMulti, setselectedMulti] = useState([]);

  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [featured, setFeatured] = useState(false);
  const [skillsold,setSkillsold]=useState([]);
  const [countrycode,setCountryCode]=useState('');
  const [countrycodeval,setCountrycodeval]=useState('');
  const [loginValuenewph,setLoginValuenewph]=useState('');
  const [verified,setVerified]=useState(false);
  const [suspended,setSuspended]=useState(false);

  let name, value;
  const handleInputs = (e) => {
    name = e.target.name;
    value = e.target.value;
    setProf({ ...prof, [name]: value });
  };

  const handleInput = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setPass({ ...pass, [name]: value });
  };

  const handleInputdata = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setUserid({ ...user, [name]: value });
  };

  const validate = (values) => {
    const errors = {};

    if (!values.experience) {
      errors.experience = "experience is required!";
    }
    return errors;
  };

  const validates = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!values.name) {
      errors.name = "Name is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    return errors;
  };
  const validate1 = (values) => {
    const errors = {};
    if (values < 4) {
      errors.mobile = "Contact number required!";
    }
    return errors;
  };



  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/professional/professional-info/${id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setProf(data.data);
      setLocation({
        name: data.data.userId.location,
        lat: data.data.userId.locationKey.coordinates[0],
        long: data.data.userId.locationKey.coordinates[1],
      });
      setaddressstring(data.data.userId.google_address_string);
      setUserid(data.data.userId);
      setMobile("+" + data.data.userId.countryCode + data.data.userId.mobile);
      setLoginValuenewph(data?.data?.userId?.mobile);
      setCountrycodeval(data?.data?.userId?.countryCode);

      setFeatured(data?.data?.featured);
      setSuspended(data?.data?.suspended);
      setVerified(data?.data?.verified);
      // setMobile("+" + data.data.userId.mobile);
      setSkillsnew(data.data.serializedSkills);
      // setSkillsold(data.data.skills);
     
    }
    else if (res.status === 401) {
      handleUnauthorized();
      getinfo();
    }
    else {

    }
  };


  const getServices = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=1`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    );


    if (res.status === 200) {
      const data1 = await res.json();
      const data = data1.data;
      setService(data);

    }
    else if (res.status === 401) {
      handleUnauthorized();
      getServices();
    }
    else {
      toast.error("error!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      // alert("error");
    }
  };

  const getServices1 = async (e) => {
    if (prof.professionalCategory) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/service-category/service-category-select?level=2`,
        {
          method: "POST",
          body: JSON.stringify({
            levelOneCategory: prof.professionalCategory,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200) {

        const data1 = await res.json();
        const data = data1.data;
        setSubcat(data[0].subCategories);
      }
      else if (res.status === 401) {
        handleUnauthorized();
        getServices1();
      }
      else {
        toast.error("error!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // alert("error");
      }
    }
  };

  const handleSkillsInput = (val) => {
    let name = "skills"
    let value = val
    setProf({ ...prof, [name]: value })
  }

  function isStringifiedJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  const PostData = async (e) => {
    e.preventDefault();
    const { experience } = prof;
    const { nam, email } = user;
    const resses = validates(user);
    const ress = validate(prof);
    const ress1 = validate1(mobile);

    setError(ress);
    setErrors(resses);
    setError1(ress1);

    let skillsjson = [];
    // let  jsonString=userprof.skills;
     let  jsonString=[];
    // if(!isStringifiedJSON(userprof?.skills)){
      const isValidJSONArray = prof?.skills.every(isStringifiedJSON);
      if(!isValidJSONArray){
      for (let i = 0; i < prof?.skills.length; i++) {
        let skillObject = {
          levelOneId: prof.professionalCategory,
          levelOneName: prof.professionalCategoryName,
          levelTwoId: prof.subCategory,
          levelTwoName: prof.subCategoryName,
          levelThreeId: prof.skills[i].levelThreeId,
          levelThreeName: prof.skills[i].levelThreeName
        };
      
        if (prof?.skills[i].levelFourId) {
          skillObject.levelFourId = prof.skills[i].levelFourId;
          skillObject.levelFourName = prof.skills[i].levelFourName;
        }
        

      skillsjson.push(skillObject);
      }
       jsonString = skillsjson.map(ski => JSON.stringify(ski));
      // jsonString= JSON.stringify(skillsjson);

    }
    else{
      jsonString =prof?.skills;

    }

    if (!resses.email && !resses.name && !ress1.mobile && !ress.experience) {
      const res = await fetch(
        `${Config.apiurl}/api/v1/crm/professional/update-professional/${id}`,
        {
          method: "PUT",

          body: JSON.stringify({
            name: user.name,
            email: user.email,
            // mobile: mobile,
            mobile: loginValuenewph,
            countryCode:countrycodeval,
            password: '#testPass1',
            confirmPassword: '#testPass1',
            // password: pass.password,
            // confirmPassword: pass.cpassword,
            verified:verified,
            suspended:suspended,
            squareFeetRate:prof.squareFeetRate,
            workingArea:prof.workingArea,
            featured:featured,
            professionalCategory: prof.professionalCategory,
            professionalType: prof.professionalType,
            experience: prof.experience,
            description: prof.description,
            location: location.name,
            latitude: location.lat,
            longitude: location.long,
            skills: jsonString,
            google_address_string: addressstring,
          }),
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      );

      if (res.status === 200) {

        setToastmodal(true);
        setToastmessage("Sucessfully Updated professional details");
        setToasttype("success");
        setToastlarge(false);
        setTimeout(() => navigate("/dashboard"), 3000);
      }
      else if (res.status === 401) {
        handleUnauthorized();
        PostData();
      }
      else {
        const data = await res.json();
        setToastmodal(true);
        setToastmessage(data.message);
        setToasttype("error");
        setToastlarge(true);
      }
    }
  };

  const handleChange = async (value) => {
    setLocation({
      name: value,
      lat: location.lat,
      long: location.long,
    });
  };

  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    Geocode.fromLatLng(latLng.lat, latLng.lng).then((response) => {
      const address = response.results[0].formatted_address;
      setaddressstring(address);
    });
    setLocation({
      name: value,
      lat: latLng.lat,
      long: latLng.lng,
    });
  };
  useEffect(() => {
    getServices();
    getServices1();
    getinfo();
  }, [prof?.professionalCategory]);

  // const handleInputsphone = (value) => {
  //   setMobile(value);
  // };

  const handleInputsphone = (phone,country) => {
    // let value = e.target.value;
    let value =phone;
    setMobile(phone);
    setCountryCode(country.countryCode)
    setCountrycodeval(country.dialCode);
    const phoneWithoutCode = value.replace(`+${country.dialCode}`, "").trim();
    setLoginValuenewph(phoneWithoutCode);

  }

  // useEffect(()=>{
  //   if(skillsold){
  //   const skills = []
  //   skillsold.map(async (skill) => {
  //       let parentCats = ""
  //       let textVal = ""
  //       console.log(skill);
  //       if (Object.keys(skill).includes("levelThreeId")) {
  //         parentCats = await getParentCategories(3, skill.levelThreeId)
  //         console.log(parentCats);
  //         textVal = skill.levelThreeName
  //       } else if (Object.keys(skill).includes("levelTwoId")) {
  //         parentCats = await getParentCategories(2, skill.levelTwoId)
  //         textVal = skill.levelTwoName
  //       } else if (Object.keys(skill).includes("levelOneId")) {
  //         parentCats = await getParentCategories(1, skill.levelOneId)
  //         textVal = skill.levelOneName
  //       }

  //       skills.push({ text: textVal, value: parentCats?.data[0] })
  //     })
    

  // setSkillsnew(skills);
  //   }
  // },[skillsold])

  return (
    <>
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Professional Edit</h4>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Name"
                            name="name"
                            value={user.name}
                            onChange={handleInputdata}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerrors.name}
                          </label>
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Email"
                            name="email"
                            value={user.email}
                            onChange={handleInputdata}
                            required
                          />
                          <label style={{ color: "red" }}>
                            {formerrors.email}
                          </label>
                        </div>
                        <div className="row">
                        <div className="form-group number col-md-6">
                          <label htmlFor="exampleInputUsername1">Mobile</label>
                          <PhoneInput
                            country={"in"}
                            enableSearch={true}
                            value={mobile}
                            onChange={ handleInputsphone}
                            // onChange={(phone) => handleInputsphone(phone)}
                          />
                          <label style={{ color: "red" }}>
                            {formerror1.mobile}
                          </label>
                        </div>
                        <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                             Verified ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="verified"
                              onChange={(e) => setVerified(e.target.value)}
                              style={{ color: "black",height:"35px" }}
                              value={verified}
                              
                            >
                              <option>Select</option>
                              <option name="verified" value={true}>
                                True
                              </option>
                              <option name="verified" value={false}>
                                False
                              </option>
                            </select>
                          </div>

                        </div>
                        {/* <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Password"
                            name="password"
                            value={pass.password}
                            onChange={handleInput}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Confirm password"
                            name="cpassword"
                            value={pass.cpassword}
                            onChange={handleInput}
                            required
                          />
                        </div> */}
                        <div className="row">
                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Professional Type
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="professionalType"
                              onChange={handleInputs}
                              style={{ color: "black" }}
                              value={prof.professionalType}
                            >
                              <option
                                {...(prof.professionalType === "freelance"
                                  ? "selected"
                                  : "")}
                              >
                                Freelance
                              </option>
                              <option
                                {...(prof.professionalType === "company"
                                  ? "selected"
                                  : "")}
                              >
                                Company
                              </option>
                            </select>
                          </div>
                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Featured ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="featured"
                              onChange={(e) => setFeatured(e.target.value)}
                              style={{ color: "black" }}
                              value={featured}
                            >
                              <option>Select</option>
                              <option name="featured" value={true}>
                                True
                              </option>
                              <option name="featured" value={false}>
                                False
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="row">
                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Professional Category
                            </label>
                            <select
                              className="form-control"
                              name="professionalCategory"
                              // onChange={handleInputs}
                              style={{ color: "black" }}
                              value={prof.professionalCategory}
                              disabled
                            >
                              {service.map((element,se) => {
                                return (
                                  <option
                                    {...(prof.professionalType === element._id
                                      ? "selected"
                                      : "")}
                                      key={se}
                                      value={element._id}
                                  >
                                    {element.categoryName}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Sub Category
                            </label>
                            <select
                              className="form-control"
                              name="subCategory"
                              // onChange={handleInputs}
                              style={{ color: "black" }}
                              value={prof.subCategory}
                              disabled
                            >
                              {/* <option></option> */}
                              {subCat.map((element, index) => {
                                return (
                                  <option
                                    name="subCategory"
                                    value={element._id}
                                    key={index}
                                  >
                                    {element.categoryName}
                                  </option>
                                );
                              })}
                            </select>
                            <label style={{ color: "red" }}>
                              {formerror.subcategory}
                            </label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="form_input_box col-sm-12 col-md-6">
                            <div className="form-group professional_skill_mul">
                              <label htmlFor="exampleInputUsername1">Skills</label>
                              {/* <ProfSkills
                               professionalCategory={prof.professionalCategory}
                               professionalSubCategory={prof.subCategory}
                               handleSkillsInput={handleSkillsInput}
                               existingValues={skillsnew}
                               /> */}
                              <SkillsMultiSelect
                              
                                professionalCategory={prof.professionalCategory}
                                professionalSubCategory={prof.subCategory}
                                handleSkillsInput={handleSkillsInput}
                                existingValues={skillsnew}
                              />
                              <label style={{ color: "red" }}>
                                {formerror.subcategory}
                              </label>
                            </div>
                          </div>
                          <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Experience
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Experience"
                              name="experience"
                              value={prof.experience}
                              onChange={handleInputs}
                              required
                            />
                            <label style={{ color: "red" }}>
                              {formerror.experience}
                            </label>
                          </div>
                        </div>
                        <div className="row">
                        <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Rating
                            </label>
                            <input
                              type="text"
                              className="form-control form_dis"
                              id="exampleInputUsername1"
                              placeholder="Rating"
                              name="rating"
                              value={prof.rating}
                              disabled
                            />
                            <label style={{ color: "red" }}>
                              {formerror.experience}
                            </label>
                          </div>

                          <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                              Square Feet Rate
                            </label>
                            <input
                              type="number"
                              className="form-control form_dis"
                              id="exampleInputUsername1"
                              placeholder="Square feet rate"
                              name="squareFeetRate"
                              value={prof.squareFeetRate}
                              onChange={handleInputs}
                            />
                            <label style={{ color: "red" }}>
                              {formerror.squareFeetRate}
                            </label>
                          </div>
                         </div>
                         
                          <div className="row">

                          <div className="form-group number col-sm-12 col-md-6">
                            <label htmlFor="exampleInputUsername1">
                            Working Area
                            </label>
                            <input
                              type="text"
                              className="form-control form_dis"
                              id="exampleInputUsername1"
                              placeholder="Working Area"
                              name="workingArea"
                              value={prof.workingArea}
                              onChange={handleInputs}
                             
                            />
                            <label style={{ color: "red" }}>
                              {formerror.workingArea}
                            </label>
                          </div>

                          <div className="form-group col-md-6">
                            <label htmlFor="exampleInputUsername1">
                             Suspended ?
                            </label>
                            <select
                              id="professionalType"
                              className="form-control"
                              name="suspended"
                              onChange={(e) => setSuspended(e.target.value)}
                              style={{ color: "black",height:"45px" }}
                              value={suspended}
                              
                            >
                              <option>Select</option>
                              <option name="suspended" value={true}>
                                True
                              </option>
                              <option name="suspended" value={false}>
                                False
                              </option>
                            </select>
                          </div>
                          </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          <textarea
                            className="form-control"
                            id="description"
                            type="text"
                            rows="5"
                            name="description"
                            placeholder="Description"
                            autoComplete="off"
                            required
                            value={prof.description}
                            onChange={handleInputs}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            Location
                          </label>
                          <PlacesAutocomplete
                            value={location.name}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            name="location"
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div className="position-relative">
                                <input
                                  className="form-control"
                                  {...getInputProps({
                                    placeholder: " Enter your location",
                                  })}
                                  required
                                />

                                <div className="autocomplete-dropdown-container">
                                  {loading ? <div>...Loading</div> : null}

                                  {suggestions.map((suggestion, key) => {
                                    const style = suggestion.active
                                      ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                        border: "1px solid #d2d2d2",
                                      }
                                      : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                        border: "1px solid #d2d2d2",
                                      };

                                    return (
                                      <div
                                        className="form-conterol"
                                        {...getSuggestionItemProps(suggestion, {
                                          style,
                                        })}
                                        key={key}
                                      >
                                        {suggestion.description}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                          {/* <input className="form-control" id="location" type="text"  name="location" placeholder="Location" autoComplete='off' required value={location.name}/> */}
                        </div>

                        <button
                          type="submit"
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}
export default Professionaledit;
